<template>
    <form @submit.prevent="submit" style="margin-bottom: 22px">
        <div class="row">
            <div class="col-sm-4">
                <label>
                    User
                </label>

              <TypeaheadWidget
                  v-model="filters.user_id"
                  name="user_id"
                  label="User"
                  endpoint="/api/v2/users"
                  :token="shared.token"
                  path="data.data"
                  placeholder="Search..."
                  :result-label-property="row => row.attributes.full_name"
              />
            </div>

            <div class="col-sm-3">
                <label>
                    Portal
                </label>

                <select-widget
                    v-model="filters.portal_id"
                    :nullable="true"
                    :options="portalOptions"
                    placeholder="(all)"
                />
            </div>

            <div class="col-sm-3">
                <label>
                    Category
                </label>

                <select-widget
                    v-model="filters.category"
                    :nullable="true"
                    :options="[{value: 'advertising', label: 'Advertising'}, {value: 'subscription', label: 'Subscription'}]"
                    placeholder="(all)"
                />
            </div>

            <div class="col-sm-3">
                <label>
                    New Business?
                </label>

                <select-widget
                    v-model="filters.is_new_business"
                    :nullable="true"
                    :options="[{value: 1, label: 'New Business'}, {value: 0, label: 'Existing Business'}]"
                    placeholder="(all)"
                />
            </div>

            <div class="col-sm-3">
                <label>
                    Expected From
                </label>

                <date-widget v-model="filters.conversion_expected_from"/>
            </div>

            <div class="col-sm-3">
                <label>
                    Expected To
                </label>

                <date-widget v-model="filters.conversion_expected_to"/>
            </div>

            <div class="col-sm-3">
                <div style="margin-bottom: 5px;">&nbsp;</div>

                <button type="submit" class="btn btn-black btn-block">
                    <i class="fa fa-filter"></i> Filter
                </button>
            </div>

            <div class="col-sm-2">
                <div style="margin-bottom: 5px;">&nbsp;</div>

                <button type="button" class="btn btn-secondary btn-block" data-toggle="modal"
                        data-target="#settings-modal">
                    <i class="fa fa-cogs"></i>
                </button>
            </div>
        </div>
    </form>
</template>

<script>
import DateWidget from '@/vendor/forms/FormGroups/Widgets/Date'
import SelectWidget from '@/vendor/forms/FormGroups/Widgets/Select'
import TypeaheadWidget from "../../../vendor/forms/FormGroups/Widgets/Typeahead.vue";
import store from '@/store'

export default {
    components: {TypeaheadWidget, DateWidget, SelectWidget},

    props: {
        value: {
            required: true,
            type: Object
        },

        portals: {
            required: true,
            type: Array
        }
    },

    data() {
        return {
            filters: {...this.value},

          shared:store
        }
    },

    watch: {
        value: {
            deep: true,
            handler: function (value) {
                this.filters = {...value}
            }
        }
    },

    computed: {
        portalOptions() {
            return this.portals.map(portal => ({value: portal.id, label: portal.attributes.name}))
        }
    },

    methods: {
        submit() {
            this.$emit('input', {...this.filters})
        }
    }
}
</script>
